import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";

export default function EditShareWithNeighborsPage() {
  return <CommunityEditPage section={SHARE_WITH_NEIGHBORS} />;
}
